export default {
  async openEditModal({
    commit,
    dispatch,
    state,
  }, id) {
    dispatch('setIsShown', true);
    commit('SET_EDIT_ID', id);
    await dispatch('getPagesList');

    const page = state.pagesList.find((obj) => obj.pageId === id) || null;

    commit('SET_IS_PAGE_EDITABLE', page);
  },

  closeEditModal({
    commit,
    dispatch,
  }) {
    dispatch('setIsShown', false);
    commit('RESET_EDITOR_STATE');
  },

  getPagesList({
    rootGetters,
    commit,
  }) {
    return rootGetters['pages/getRepository'].list()
      .then((response) => {
        commit('SET_PAGES_LIST', response);
      });
  },

  updateIsPageField({
    commit,
  }, payload) {
    commit('UPDATE_IS_PAGE_FIELD', payload);
  },

  updateTranslation({
    commit,
  }, payload) {
    commit('UPDATE_TRANSLATION', payload);
  },
  async updatePage({
    state,
    rootGetters,
    dispatch,
  }) {
    const repository = rootGetters['pages/getRepository'];
    const id = state.editId || state.isPageEditable?.id;
    const src = state.isPageEditable?.translations || {};
    const translations = Object.keys(src).reduce((acc, loc) => {
      const translation = src[loc] || {};

      acc[loc] = {
        name: translation.name ?? state.isPageEditable?.name ?? '',
        meta_title: translation.metaTitle ?? '',
        meta_description: translation.metaDescription ?? '',
      };

      return acc;
    }, {});
    const payload = {
      translations,
      page_id: id,
    };
    const hasPanelId = Boolean(state.isPageEditable?.panelId);

    if (hasPanelId) {
      await repository.update(state.isPageEditable.mainId, payload);
    } else {
      await repository.save(payload);
    }

    await dispatch('pages/table/fetch', null, { root: true });
    await dispatch('getPagesList');
  },
  setIsShown({ commit }, value) {
    commit('SET_IS_SHOWN', Boolean(value));
  },
};
